import React, { Component } from "react"
import PropTypes from "prop-types"
import styles from "./styles.less"
import Checkbox from "./Checkbox.jsx"

export default class CheckboxList extends Component {
  static propTypes = {
    collection: PropTypes.array.isRequired,
    selected: PropTypes.array,
    onChange: PropTypes.func,
    emptyText: PropTypes.string,
    showTooltip: PropTypes.bool,
  }

  state = {
    selected: this.props.selected || [],
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selected: nextProps.selected || [],
    })
  }

  handleChange(item, event) {
    var selected = event.target.checked
      ? [...this.state.selected, item.id]
      : this.state.selected.filter((o) => o != item.id)
    this.props.onChange && this.props.onChange(selected)
    this.setState({
      selected: selected,
    })
  }

  renderChildren() {
    return this.props.collection.map((o) => {
      return (
        <Checkbox
          key={o.id}
          label={o.title}
          badge={o.count}
          showTooltip={this.props.showTooltip}
          checked={this.state.selected.indexOf(o.id) != -1}
          onChange={(event) => this.handleChange(o, event)}
        />
      )
    })
  }

  render() {
    return (
      <div className={styles.list} data-empty={this.props.emptyText}>
        {this.renderChildren()}
      </div>
    )
  }
}
